import React, { useState } from 'react'
import { useEffect } from 'react';
import { useRef } from 'react';

export default function DropDownPrint({ value, width, list, onChangeValue, selectedValue, onClick, show, onClickList, placeholder ,blackClass}) {

    const [data, setData] = useState(list);
    const [inputVal, setinputVal] = useState('');
    const [visible, setVisible] = useState(false)
    const num = [1232, 5165, 615498, 65165, 1232, 5165, 615498, 65165, 1232, 5165, 615498, 65165, 1232, 5165, 615498, 65165]
    function useOutsideAlerter(ref) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    // alert("You clicked outside of me!");
                    setVisible(false)
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    const handler = () => {
        setVisible(true)

    }
    const listData = (data) => {
        onClickList(data)
        setinputVal(data.name)
        console.log(inputVal);
        console.log(data);
    }

    return (
        <div style={{ width: '200px' }} ref={wrapperRef}>
            <div onClick={() => handler()} >
                <input className={`${blackClass || "drop-input"}`}  onChange={(e) => setinputVal(e.target.value)} value={inputVal} placeholder={placeholder} defaultValue={placeholder} />
            </div>
            {
                visible ?
                    <div style={{ position: 'relative' }}>
                        <div className='picker-list drop-input'>

                            {
                                list ?
                                    list.filter((item => String(item.name).toLowerCase()?.includes(inputVal?.toLowerCase())))
                                    .map(data =>
                                        <React.Fragment>
                                            <div key={data} className='dropdown-para-wrapper'>
                                                <p onClick={() => listData(data)}>{data.name}</p>
                                            </div>
                                        </React.Fragment>
                                    ) :
                                    num.map(data =>
                                        <React.Fragment>
                                            <div key={data} className='dropdown-para-wrapper'>
                                                <p onClick={() => listData(data)}>{data}</p>
                                            </div>
                                        </React.Fragment>
                                    )
                            }
                        </div> </div> :
                    null
            }

        </div>
    )
}
